import React from 'react';

function KnowledgePage() {
  return (
    <div style={{ padding: '2rem', minHeight: '60vh' }}>
      <h1>飛鏢知識</h1>
      <p>此頁面內容開發中...</p>
    </div>
  );
}

export default KnowledgePage;
